/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RecommendationsIndexRouteImport } from './routes/recommendations/index'
import { Route as HoldingsIndexRouteImport } from './routes/holdings/index'
import { Route as FundsIndexRouteImport } from './routes/funds/index'
import { Route as ExploreIndexRouteImport } from './routes/explore/index'
import { Route as AaIndexRouteImport } from './routes/aa/index'
import { Route as RecommendationsRecommendationIdRouteImport } from './routes/recommendations/$recommendationId'
import { Route as HoldingsHoldingIdRouteImport } from './routes/holdings/$holdingId'
import { Route as FundsFundIdRouteImport } from './routes/funds/$fundId'
import { Route as ExploreFundIdRouteImport } from './routes/explore/$fundId'
import { Route as AaCallbackRouteImport } from './routes/aa/callback'
import { Route as AaAccountsRouteImport } from './routes/aa/accounts'

const CompareRoute = CompareRouteImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecommendationsIndexRoute = RecommendationsIndexRouteImport.update({
  id: '/recommendations/',
  path: '/recommendations/',
  getParentRoute: () => rootRouteImport,
} as any)
const HoldingsIndexRoute = HoldingsIndexRouteImport.update({
  id: '/holdings/',
  path: '/holdings/',
  getParentRoute: () => rootRouteImport,
} as any)
const FundsIndexRoute = FundsIndexRouteImport.update({
  id: '/funds/',
  path: '/funds/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreIndexRoute = ExploreIndexRouteImport.update({
  id: '/explore/',
  path: '/explore/',
  getParentRoute: () => rootRouteImport,
} as any)
const AaIndexRoute = AaIndexRouteImport.update({
  id: '/aa/',
  path: '/aa/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecommendationsRecommendationIdRoute =
  RecommendationsRecommendationIdRouteImport.update({
    id: '/recommendations/$recommendationId',
    path: '/recommendations/$recommendationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const HoldingsHoldingIdRoute = HoldingsHoldingIdRouteImport.update({
  id: '/holdings/$holdingId',
  path: '/holdings/$holdingId',
  getParentRoute: () => rootRouteImport,
} as any)
const FundsFundIdRoute = FundsFundIdRouteImport.update({
  id: '/funds/$fundId',
  path: '/funds/$fundId',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreFundIdRoute = ExploreFundIdRouteImport.update({
  id: '/explore/$fundId',
  path: '/explore/$fundId',
  getParentRoute: () => rootRouteImport,
} as any)
const AaCallbackRoute = AaCallbackRouteImport.update({
  id: '/aa/callback',
  path: '/aa/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AaAccountsRoute = AaAccountsRouteImport.update({
  id: '/aa/accounts',
  path: '/aa/accounts',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/compare': typeof CompareRoute
  '/aa/accounts': typeof AaAccountsRoute
  '/aa/callback': typeof AaCallbackRoute
  '/explore/$fundId': typeof ExploreFundIdRoute
  '/funds/$fundId': typeof FundsFundIdRoute
  '/holdings/$holdingId': typeof HoldingsHoldingIdRoute
  '/recommendations/$recommendationId': typeof RecommendationsRecommendationIdRoute
  '/aa': typeof AaIndexRoute
  '/explore': typeof ExploreIndexRoute
  '/funds': typeof FundsIndexRoute
  '/holdings': typeof HoldingsIndexRoute
  '/recommendations': typeof RecommendationsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/compare': typeof CompareRoute
  '/aa/accounts': typeof AaAccountsRoute
  '/aa/callback': typeof AaCallbackRoute
  '/explore/$fundId': typeof ExploreFundIdRoute
  '/funds/$fundId': typeof FundsFundIdRoute
  '/holdings/$holdingId': typeof HoldingsHoldingIdRoute
  '/recommendations/$recommendationId': typeof RecommendationsRecommendationIdRoute
  '/aa': typeof AaIndexRoute
  '/explore': typeof ExploreIndexRoute
  '/funds': typeof FundsIndexRoute
  '/holdings': typeof HoldingsIndexRoute
  '/recommendations': typeof RecommendationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/compare': typeof CompareRoute
  '/aa/accounts': typeof AaAccountsRoute
  '/aa/callback': typeof AaCallbackRoute
  '/explore/$fundId': typeof ExploreFundIdRoute
  '/funds/$fundId': typeof FundsFundIdRoute
  '/holdings/$holdingId': typeof HoldingsHoldingIdRoute
  '/recommendations/$recommendationId': typeof RecommendationsRecommendationIdRoute
  '/aa/': typeof AaIndexRoute
  '/explore/': typeof ExploreIndexRoute
  '/funds/': typeof FundsIndexRoute
  '/holdings/': typeof HoldingsIndexRoute
  '/recommendations/': typeof RecommendationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/compare'
    | '/aa/accounts'
    | '/aa/callback'
    | '/explore/$fundId'
    | '/funds/$fundId'
    | '/holdings/$holdingId'
    | '/recommendations/$recommendationId'
    | '/aa'
    | '/explore'
    | '/funds'
    | '/holdings'
    | '/recommendations'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/compare'
    | '/aa/accounts'
    | '/aa/callback'
    | '/explore/$fundId'
    | '/funds/$fundId'
    | '/holdings/$holdingId'
    | '/recommendations/$recommendationId'
    | '/aa'
    | '/explore'
    | '/funds'
    | '/holdings'
    | '/recommendations'
  id:
    | '__root__'
    | '/'
    | '/compare'
    | '/aa/accounts'
    | '/aa/callback'
    | '/explore/$fundId'
    | '/funds/$fundId'
    | '/holdings/$holdingId'
    | '/recommendations/$recommendationId'
    | '/aa/'
    | '/explore/'
    | '/funds/'
    | '/holdings/'
    | '/recommendations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CompareRoute: typeof CompareRoute
  AaAccountsRoute: typeof AaAccountsRoute
  AaCallbackRoute: typeof AaCallbackRoute
  ExploreFundIdRoute: typeof ExploreFundIdRoute
  FundsFundIdRoute: typeof FundsFundIdRoute
  HoldingsHoldingIdRoute: typeof HoldingsHoldingIdRoute
  RecommendationsRecommendationIdRoute: typeof RecommendationsRecommendationIdRoute
  AaIndexRoute: typeof AaIndexRoute
  ExploreIndexRoute: typeof ExploreIndexRoute
  FundsIndexRoute: typeof FundsIndexRoute
  HoldingsIndexRoute: typeof HoldingsIndexRoute
  RecommendationsIndexRoute: typeof RecommendationsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/compare': {
      id: '/compare'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof CompareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recommendations/': {
      id: '/recommendations/'
      path: '/recommendations'
      fullPath: '/recommendations'
      preLoaderRoute: typeof RecommendationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/holdings/': {
      id: '/holdings/'
      path: '/holdings'
      fullPath: '/holdings'
      preLoaderRoute: typeof HoldingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/funds/': {
      id: '/funds/'
      path: '/funds'
      fullPath: '/funds'
      preLoaderRoute: typeof FundsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/': {
      id: '/explore/'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof ExploreIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aa/': {
      id: '/aa/'
      path: '/aa'
      fullPath: '/aa'
      preLoaderRoute: typeof AaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recommendations/$recommendationId': {
      id: '/recommendations/$recommendationId'
      path: '/recommendations/$recommendationId'
      fullPath: '/recommendations/$recommendationId'
      preLoaderRoute: typeof RecommendationsRecommendationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/holdings/$holdingId': {
      id: '/holdings/$holdingId'
      path: '/holdings/$holdingId'
      fullPath: '/holdings/$holdingId'
      preLoaderRoute: typeof HoldingsHoldingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/funds/$fundId': {
      id: '/funds/$fundId'
      path: '/funds/$fundId'
      fullPath: '/funds/$fundId'
      preLoaderRoute: typeof FundsFundIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore/$fundId': {
      id: '/explore/$fundId'
      path: '/explore/$fundId'
      fullPath: '/explore/$fundId'
      preLoaderRoute: typeof ExploreFundIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aa/callback': {
      id: '/aa/callback'
      path: '/aa/callback'
      fullPath: '/aa/callback'
      preLoaderRoute: typeof AaCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aa/accounts': {
      id: '/aa/accounts'
      path: '/aa/accounts'
      fullPath: '/aa/accounts'
      preLoaderRoute: typeof AaAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CompareRoute: CompareRoute,
  AaAccountsRoute: AaAccountsRoute,
  AaCallbackRoute: AaCallbackRoute,
  ExploreFundIdRoute: ExploreFundIdRoute,
  FundsFundIdRoute: FundsFundIdRoute,
  HoldingsHoldingIdRoute: HoldingsHoldingIdRoute,
  RecommendationsRecommendationIdRoute: RecommendationsRecommendationIdRoute,
  AaIndexRoute: AaIndexRoute,
  ExploreIndexRoute: ExploreIndexRoute,
  FundsIndexRoute: FundsIndexRoute,
  HoldingsIndexRoute: HoldingsIndexRoute,
  RecommendationsIndexRoute: RecommendationsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
